/** Copy for /b2b bakery case. Keep in sync with sales/ukraine/CASE_BAKERY_OVENS.md */

export const B2B_BAKERY_CASE_COPY = {
  ua: {
    figureAlt: 'Картка акумулятора у Вирій ЕМС: потужність, залишок заряду SoC і ціна кіловат-години',
    headline: 'Візок вже в печі, а батареї не вистачило до кінця циклу. Знайома історія?',
    introBefore: 'Зараз розкажемо, як ',
    emsName: 'Вирій ЕМС',
    introAfter: ' показує начальнику зміни залишок батареї до того, як візок заїде в піч.',
    lead: 'Партнер 220-km: пекарня, два кабінети Deye на 500+ кВт·год, десять ротаційних печей по 30 кВт, у розігріві по 60 кВт (3 працюють зараз).',
    wasTitle: 'Було',
    wasBody: [
      'Ротаційна піч: чотири стінки, ТЕНи тільки ззаду, гріється лише задня. Візок обертається, щоб продукція пропікалась рівно.',
      'Цикл не можна обривати. Коли заряду не вистачало посеред випікання, продукція виходила недопеченою. Це порушення технології.',
    ],
    changedTitle: 'Що змінили',
    changedBody: [
      'Начальник зміни бачить у Вирій ЕМС, скільки відсотків батареї залишилось, і вирішує: ставити візок у піч чи ні.',
    ],
    decisionTitle: 'Як приймають рішення',
    decisionBody: [
      'Розігрів однієї печі — 60 кВт, далі піч тримає 30 кВт. Десять печей у розігріві — до 600 кВт. Старт без запасу заряду обриває цикл.',
      'ЕМС показує SoC ще до старту. Начальник зміни сам вирішує, чи вистачить заряду довести випікання до кінця.',
    ],
    betterTitle: 'Стало',
    betterBody: ['Усе випікається. Недопеченої продукції немає, технологія не зривається.'],
    source: 'Живий обʼєкт на Вирій ЕМС',
  },
  ru: {
    figureAlt: 'Карточка аккумулятора в Вирий ЭМС: мощность, остаток заряда SoC и цена киловатт-часа',
    headline: 'Тележка уже в печи, а батареи не хватило до конца цикла. Знакомая история?',
    introBefore: 'Сейчас расскажем, как ',
    emsName: 'Вирий ЭМС',
    introAfter: ' показывает начальнику смены остаток батареи до того, как тележка заедет в печь.',
    lead: 'Партнёр 220-km: пекарня, два кабинета Deye на 500+ кВт·ч, десять ротационных печей по 30 кВт, в разогреве по 60 кВт (3 работают сейчас).',
    wasTitle: 'Было',
    wasBody: [
      'Ротационная печь: четыре стенки, ТЭНы только сзади, греется только задняя. Тележка вращается, чтобы продукция пропекалась ровно.',
      'Цикл нельзя обрывать. Когда заряда не хватало посреди выпечки, продукция выходила недопеченной. Это нарушение технологии.',
    ],
    changedTitle: 'Что изменили',
    changedBody: [
      'Начальник смены видит в Вирий ЭМС, сколько процентов батареи осталось, и решает: ставить тележку в печь или нет.',
    ],
    decisionTitle: 'Как принимают решение',
    decisionBody: [
      'Разогрев одной печи — 60 кВт, дальше печь держит 30 кВт. Десять печей в разогреве — до 600 кВт. Старт без запаса заряда обрывает цикл.',
      'ЭМС показывает SoC ещё до старта. Начальник смены сам решает, хватит ли заряда довести выпечку до конца.',
    ],
    betterTitle: 'Стало',
    betterBody: ['Всё выпекается. Недопеченной продукции нет, технология не срывается.'],
    source: 'Живой объект на Вирий ЭМС',
  },
  en: {
    figureAlt: 'Viriy EMS battery card: power, state of charge, and the price per kilowatt-hour',
    headline: 'The trolley is already in the oven, and the battery runs out before the cycle ends. Sound familiar?',
    introBefore: 'Here is how ',
    emsName: 'Viriy EMS',
    introAfter: ' shows the shift lead how much battery is left before the trolley goes into the oven.',
    lead: 'A 220-km partner: a bakery, two Deye cabinets, 500+ kWh, ten rotary ovens at 30 kW each, 60 kW in heat-up (3 running now).',
    wasTitle: 'Before',
    wasBody: [
      'A rotary oven: four walls, heating elements only at the back, and only the rear wall heats. The trolley rotates so the batch bakes evenly.',
      'You cannot cut the cycle short. When the battery ran out mid-bake, the product came out underbaked. That is a process violation.',
    ],
    changedTitle: 'What changed',
    changedBody: [
      'The shift lead sees the remaining battery percent in Viriy EMS and decides whether to put the trolley in the oven.',
    ],
    decisionTitle: 'How the decision is made',
    decisionBody: [
      'Heat-up is 60 kW per oven, then 30 kW to hold temperature. Ten ovens in heat-up is up to 600 kW. Starting without enough charge cuts the bake short.',
      'EMS shows SoC before the start. The shift lead decides whether the charge will carry the bake to the end.',
    ],
    betterTitle: 'After',
    betterBody: ['The whole batch bakes through. No underbaked product, and the process holds.'],
    source: 'Live site on Viriy EMS',
  },
};

export function getB2bBakeryCaseCopy(language) {
  const lang = String(language || 'ua').toLowerCase();
  if (lang.startsWith('en')) return B2B_BAKERY_CASE_COPY.en;
  if (lang.startsWith('ru')) return B2B_BAKERY_CASE_COPY.ru;
  return B2B_BAKERY_CASE_COPY.ua;
}
